import { ChatFixture, tokenize } from './types';

/**
 * Journey 1 — voice-chat.
 *
 * The user "says" (via the mic transcription simulation):
 *   "What if AI could run your law firm?"
 *
 * Prest0n replies:
 *   "Let me show you." + a short framing sentence.
 */
export const chatVoiceFixture: ChatFixture = {
  id: 'chat-voice',
  userQuery: 'What if AI could run your law firm?',
  // No voiceReplyUrl, deliberately. It pointed at
  // /moonshot/audio/chat-voice-reply.mp3, which has never existed — and
  // MoonshotVoiceChat renders a speaker button whenever this field is set,
  // then plays it with `new Audio(url).play().catch(() => undefined)`. So a
  // viewer clicked a speaker icon, the browser fetched 28KB of index.html
  // (the SPA fallback answers 200, never 404), playback failed, and the
  // catch swallowed it: a dead button in a demo, silent by construction.
  // The button does not render without this field, which is the better of
  // the two states available until a real clip exists. Add one to
  // public/moonshot/audio/ and restore the line together.
  steps: [
    'mic-listen',
    'transcribe',
    'assistant-thinking',
    'assistant-stream',
    'voice-playback',
  ],
  chunks: [
    { delta: '', delayMs: 200, event: 'thinking', data: { label: 'Assessing...' } },
    ...tokenize(
      'Let me show you. In the next thirty seconds I will research California wrongful-termination ' +
        'precedent, summarize a client intake packet, draft a demand letter, translate it into Spanish, ' +
        'and surface every integration your firm runs on — all from this one chat.',
      55,
    ),
  ],
};

export default chatVoiceFixture;
